export const translations = {
	en: {
		days: ['day', 'days', 'days'],
		hours: ['hour', 'hours', 'hours'],
		minutes: ['minute', 'minutes', 'minutes'],
		seconds: ['second', 'seconds', 'seconds'],
		finished: 'Countdown finished!',
	},
	es: {
		days: ['día', 'días', 'días'],
		hours: ['hora', 'horas', 'horas'],
		minutes: ['minuto', 'minutos', 'minutos'],
		seconds: ['segundo', 'segundos', 'segundos'],
		finished: '¡Cuenta atrás terminada!',
	},
	de: {
		days: ['Tag', 'Tage', 'Tage'],
		hours: ['Stunde', 'Stunden', 'Stunden'],
		minutes: ['Minute', 'Minuten', 'Minuten'],
		seconds: ['Sekunde', 'Sekunden', 'Sekunden'],
		finished: 'Countdown beendet!',
	},
	fr: {
		days: ['jour', 'jours', 'jours'],
		hours: ['heure', 'heures', 'heures'],
		minutes: ['minute', 'minutes', 'minutes'],
		seconds: ['seconde', 'secondes', 'secondes'],
		finished: 'Compte à rebours terminé!',
	},
	el: {
		days: ['μέρα', 'μέρες', 'μέρες'],
		hours: ['ώρα', 'ώρες', 'ώρες'],
		minutes: ['λεπτό', 'λεπτά', 'λεπτά'],
		seconds: ['δεύτερο', 'δευτερόλεπτα', 'δευτερόλεπτα'],
		finished: 'Η αντίστροφη μέτρηση ολοκληρώθηκε!',
	},
	it: {
		days: ['giorno', 'giorni', 'giorni'],
		hours: ['ora', 'ore', 'ore'],
		minutes: ['minuto', 'minuti', 'minuti'],
		seconds: ['secondo', 'secondi', 'secondi'],
		finished: 'Conto alla rovescia terminato!',
	},
	pl: {
		days: ['dzień', 'dni', 'dni'],
		hours: ['godzina', 'godziny', 'godzin'],
		minutes: ['minuta', 'minuty', 'minut'],
		seconds: ['sekunda', 'sekundy', 'sekund'],
		finished: 'Odliczanie zakończone!',
	},
	pt: {
		days: ['dia', 'dias', 'dias'],
		hours: ['hora', 'horas', 'horas'],
		minutes: ['minuto', 'minutos', 'minutos'],
		seconds: ['segundo', 'segundos', 'segundos'],
		finished: 'Contagem regressiva terminada!',
	},
};
